/* eslint no-new: "off" */

import $ from "jquery";
import FileService from "./Service/FileService";
import MachineryService from "./Service/MachineryService";
import {
  removeRequiredAttribute,
  setRequiredAttribute,
} from "./Service/ServiceFunctions";

class MachineryManager {
  /**
   * contain machinery html objects
   *
   * @property
   * @type {Object}
   */
  $machinery;

  /**
   * contains current visible registration index
   *
   * @property currentIndexOfRegistration
   * @type {number}
   */
  currentIndexOfRegistration = 0;

  /**
   * sum of registrations
   *
   * @property indexOfMaxRegistrations
   * @type {number}
   *
   */
  indexOfMaxRegistrations = 0;

  /**
   *  registration button
   *
   * @property $addRegistrationSection
   * @type {Object}
   */
  $addRegistrationSection;

  /**
   * contains delete button identifier
   * @type {string}
   */
  deletButtonID = ".js-machinery-delete";

  /**
   * contains delete button identifier
   * @type {string}
   */
  machineryInit = $(".js-machinery-content").attr("data-js-init");

  /**
   * contains (in live time) the last registration
   * @type {object}
   */
  $currentMachinery = {};

  /**
   * instance of machinery software service
   *
   * @property machineryService
   * @type {MachineryService}
   */
  machineryService;

  /**
   * instance of file service
   *
   * @property fileService
   * @type {FileService}
   */
  fileService;

  /**
   * machine availability
   *
   * @property machineAvailability
   * @type {boolean}
   */
  machineAvailability = true;

  constructor() {
    this.fileService = new FileService();
    this.$machinery = $(".js-machinery");
    this.indexOfMaxRegistrations = this.$machinery.length;
    this.$addRegistrationSection = $(".js-add-registration");

    this.setRegistrationAvailability();
    this.$currentMachinery = $(
      this.$machinery[this.currentIndexOfRegistration]
    );

    if (this.machineAvailability) {
      this.$addRegistrationSection.show();
      this.machineryService = new MachineryService(
        this.$machinery,
        this.machineAvailability
      );
      this.registrationButtonOnClick();
      this.activateAllDeleteButtons();
      this.initByStoredData();
    }
  }

  initByStoredData() {
    // while next current machine has an controller type value (means a form submit done before) try to restore data for it
    let whileRuns = 0;
    let startIndexToCleanRecentSelected = 0;
    while (
      $(this.$machinery[this.currentIndexOfRegistration])
        .find(".js-machinery-control-type")
        .val() &&
      whileRuns < this.$machinery.length
    ) {
      this.addRegistration();
      whileRuns += 1;
    }

    // add one registration if none done before
    if (this.currentIndexOfRegistration === 0 && this.machineryInit) {
      this.addRegistration();
    } else {
      startIndexToCleanRecentSelected = this.currentIndexOfRegistration;
    }

    // DELETE all that are same or above index that used when found in local storage
    for (
      let i = startIndexToCleanRecentSelected;
      i < this.$machinery.length;
      i += 1
    ) {
      this.machineryService.removeRecentSelected(i);
    }

    // when used stored data
    if (this.currentIndexOfRegistration) {
      // enable add more machine buttons
      this.$addRegistrationSection.show();
    }
  }

  /**
   * set availability of registration
   *
   * @method setRegistrationAvailability
   */
  setRegistrationAvailability() {
    this.machineAvailability =
      this.indexOfMaxRegistrations > this.currentIndexOfRegistration;
  }

  /**
   * enable on click function
   *
   * @method registrationButtonOnClick
   */
  registrationButtonOnClick() {
    this.$addRegistrationSection.find(".cta-btn--sm").click(() => {
      this.addRegistration();
    });
  }

  /**
   * enable on click function
   *
   * @method registrationButtonOnClick
   */
  addRegistration() {
    // add new registration
    this.$currentMachinery = $(
      this.$machinery[this.currentIndexOfRegistration]
    );
    this.$currentMachinery.show();
    setRequiredAttribute(this.$currentMachinery, ".js-required");

    // handle data (software, gimmick) from last submit stored at localstorage
    this.machineryService.handleMachineController(
      this.$currentMachinery,
      this.currentIndexOfRegistration
    );

    // increment index for next possible machine
    this.currentIndexOfRegistration += 1;

    // enable delete button on this registration
    this.setVisibilityOnCurrentDeleteButton(this.$currentMachinery);

    // hide button
    this.$addRegistrationSection.hide();
    this.setRegistrationAvailability();
  }

  /**
   * @method activateAllDeleteButtons
   */
  activateAllDeleteButtons() {
    $(this.deletButtonID).click(() => {
      // Delete not the first machinery
      if (this.currentIndexOfRegistration > 0) {
        this.deleteCurrentMachinery();
      }
    });
  }

  /**
   * @method deleteCurrentMachinery
   */
  deleteCurrentMachinery() {
    // reset current machinery
    this.currentIndexOfRegistration -= 1;
    this.$currentMachinery = $(
      this.$machinery[this.currentIndexOfRegistration]
    );

    // clean form and hide current machinery form
    this.cleanCurrentMachinery();
    this.$addRegistrationSection.show();
    this.$currentMachinery.hide();

    // hide all delete buttons enable and show last one
    this.setVisibilityOnCurrentDeleteButton(
      $(this.$machinery[this.currentIndexOfRegistration - 1])
    );
  }

  /**
   * @method setVisibilityOnCurrentDeleteButton
   * @property $currentMachinery
   */
  setVisibilityOnCurrentDeleteButton($currentMachinery) {
    // hide all delete buttons
    $(this.deletButtonID).hide();
    // show and enable current delete button (only > one machinery)
    if (this.currentIndexOfRegistration > 1) {
      $($currentMachinery.find(this.deletButtonID)).show();
    }
  }

  /**
   * @method cleanCurrentMachinery
   */
  cleanCurrentMachinery() {
    // clean all fields
    removeRequiredAttribute(this.$currentMachinery, ".js-required");
    this.$currentMachinery.find("input").val("");
    this.$currentMachinery.find(".js-machinery-software").empty();
    this.$currentMachinery.find(".js-machinery-control-type").val("");
    this.$currentMachinery.find(".js-documentation option").empty();
    this.$currentMachinery.find(".js-software-option option").empty();
    this.$currentMachinery.find(".js-gimmicks").hide();

    // machineryservice remove localstorage for machinery index
    this.machineryService.removeRecentSelected(this.currentIndexOfRegistration);

    // if a files exist, delete this from Server and reset the upload field
    if (this.$currentMachinery.find(".js-remove-file").length) {
      this.fileService.deleteProcessor(
        this.$currentMachinery,
        this.$currentMachinery.find(".js-remove-file")
      );
    }

    // if a error ist visible, reset this upload field
    if (this.$currentMachinery.find(".js-file-error").length) {
      this.$currentMachinery.find(".js-file-error").remove();
      this.$currentMachinery
        .find(this.fileService.uploadIdentifier)
        .show()
        .val("");
      this.fileService.enableForm();
    }
  }
}

(() => {
  if ($(".js-machinery").length) {
    new MachineryManager();
  }
})();
